import { useMutation, useQuery } from 'react-query';
import { AxiosError } from 'axios';
import { RemoteEventRepo } from '@repository/event/EventRepo';
import { EventType } from '@domain/constant/event/EventType';
import useArrayBufferErrorHandler from '@utils/hooks/useArrayBufferErrorHandler';

export const keys = ['event'];

const remoteEventRepo = new RemoteEventRepo();

export const fetchEventsAccMbtiApply = async () => {
  const { data } = await remoteEventRepo.fetchEventsAccMbtiApply();
  return data;
};

export const fetchEventsTalentPoolAccaTestApply = async () => {
  const { data } = await remoteEventRepo.fetchEventsTalentPoolAccaTestApply();
  return data;
};

export const fetchEventsTalentPoolFinalApply = async () => {
  const { data } = await remoteEventRepo.fetchEventsTalentPoolFinalApply();
  return data;
};

export const fetchEventsTalentPoolProfileApply = async () => {
  const { data } = await remoteEventRepo.fetchEventsTalentPoolProfileApply();
  return data;
};

export const fetchEventsTalentPoolUserStatus = async () => {
  const { data } = await remoteEventRepo.fetchEventsTalentPoolUserStatus();
  return data.talentPoolEventDto;
};

export const fetchDownloadTalentPoolResume = async () => {
  const { data } = await remoteEventRepo.fetchDownloadTalentPoolResume();
  return data;
};

// 추석이벤트
export const fetchEventsParticipationStatus = async (eventType: EventType) => {
  const { data } = await remoteEventRepo.fetchEventsParticipationStatus(eventType);
  return data;
};

export const fetchEventsHolidayApply = async () => {
  const { data } = await remoteEventRepo.fetchEventsHolidayApply();
  return data;
};

export const fetchEventsProfileDownload = async () => {
  const { data } = await remoteEventRepo.fetchEventsProfileDownload();
  return data;
};

export const fetchEventsMatchingApply = async (url: string) => {
  const { data } = await remoteEventRepo.fetchEventsMatchingApply(url);
  return data;
};

// 프로필 완성 이벤트
export const fetchEventProfileApply = async () => {
  const { data } = await remoteEventRepo.fetchEventProfileApply();
  return data;
};

// useQuery ///
export function useEventsTalentPoolUserStatus(isEnabled: boolean) {
  return useQuery([...keys, 'talentPool', 'userStatus'], fetchEventsTalentPoolUserStatus, {
    enabled: isEnabled,
    refetchOnWindowFocus: true,
  });
}

export function useEventsParticipationStatus(eventType: EventType) {
  return useQuery([...keys, 'participationStatus', eventType], () => fetchEventsParticipationStatus(eventType));
}

// useMutation ///
export function useEventsAccMbtiApply(onSuccess?: () => void, onError?: (e: AxiosError) => void) {
  return useMutation(fetchEventsAccMbtiApply, {
    onSuccess,
    onError,
  });
}

export function useEventsTalentPoolAccaTestApply(onSuccess?: () => void, onError?: (e: AxiosError) => void) {
  return useMutation(fetchEventsTalentPoolAccaTestApply, {
    onSuccess,
    onError,
  });
}

export function useEventsTalentPoolFinalApply(onSuccess?: () => void, onError?: (e: AxiosError) => void) {
  return useMutation(fetchEventsTalentPoolFinalApply, {
    onSuccess,
    onError,
  });
}

export function useEventsTalentPoolProfileApply(onSuccess?: () => void, onError?: (e: AxiosError) => void) {
  return useMutation(fetchEventsTalentPoolProfileApply, {
    onSuccess,
    onError,
  });
}

export function useDownloadTalentPoolResume(
  onSuccess?: (data: ArrayBuffer) => void,
  onError?: (e: AxiosError) => void,
) {
  return useMutation(fetchDownloadTalentPoolResume, {
    onSuccess,
    onError,
  });
}

export function useEventsHolidayApply(onSuccess?: () => void, onError?: (e: AxiosError) => void) {
  return useMutation(fetchEventsHolidayApply, {
    onSuccess,
    onError,
  });
}

export function useEventsProfileDownload(onSuccess?: (data: ArrayBuffer) => void, onError?: (e: AxiosError) => void) {
  const handleError = useArrayBufferErrorHandler(onError);

  return useMutation(fetchEventsProfileDownload, {
    onSuccess,
    onError: handleError,
  });
}

export function useEventsMatchingApply(onSuccess?: () => void, onError?: (e: AxiosError) => void) {
  return useMutation((url: string) => fetchEventsMatchingApply(url), {
    onSuccess,
    onError,
  });
}

export function useEventsProfileApply(onSuccess?: () => void, onError?: (e: AxiosError) => void) {
  return useMutation(fetchEventProfileApply, {
    onSuccess,
    onError,
  });
}

const fetchJbtiUsers = async () => {
  const { data } = await remoteEventRepo.fetchJbtiUsers();
  return data;
};

export const useJbtiUsers = () => {
  return useQuery([...keys, 'jbtiUsers'], fetchJbtiUsers);
};

//이벤트 시작날짜 ~ 종료날짜
export const fetchEventDateStatus = async (eventType: EventType) => {
  const { data } = await remoteEventRepo.fetchEventDate(eventType);
  return data;
};

export function useEventDate(eventType: EventType) {
  return useQuery([...keys], () => fetchEventDateStatus(eventType));
}
